<template>
  <div>
    <h2 class="has-text-centered subtitle">
      {{ $t("products.stockValue") }}
    </h2>

    <div class="columns has-text-centered is-mobile is-multiline">
      <stock-value-card
        :text="$t('products.salePrice')"
        :description="$t('products.salePriceDescription')"
        :hasCurrencySymbol="true"
        :value="stockValueByPrice * 100"
      />

      <stock-value-card
        :text="$t('products.cost')"
        :description="$t('products.costDescription')"
        :hasCurrencySymbol="true"
        :value="stockValueByLastCost * 100"
      />

      <stock-value-card
        :text="$t('products.averageMargin')"
        :description="$t('products.averageMarginDescription')"
        :hasCurrencySymbol="false"
        :value="(averageMargin * 100).toFixed(1)"
      />
    </div>

    <h2 v-if="stockWithoutLastCost" class="has-text-centered has-text-danger">
      {{
        stockWithoutLastCost > 1
          ? $t("products.stockWithoutCostNotePlural", {
              quantity: stockWithoutLastCost
            })
          : $t("products.stockWithoutCostNote", {
              quantity: stockWithoutLastCost
            })
      }}
    </h2>
    <br />
  </div>
</template>

<script>
import stockValueCard from "./StockValueCard";

export default {
  props: ["products"],

  components: {
    stockValueCard
  },

  computed: {
    stockValueByPrice() {
      return this.products.reduce((t, p) => {
        return t + p.p * (p.cq || 0);
      }, 0);
    },

    stockValueByLastCost() {
      return this.products.reduce((t, p) => {
        return p.lc ? t + p.lc * (p.cq || 0) : t;
      }, 0);
    },

    stockWithoutLastCost() {
      return this.products.filter(p => {
        return p.cq && p.cq != 0 && !p.lc;
      }).length;
    },

    averageMargin() {
      return (
        (this.stockValueByPrice - this.stockValueByLastCost) /
        this.stockValueByPrice
      );
    }
  }
};
</script>
